import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	/**
	 * @brief 시작화면
	 */
	{
		name: 'home',
		path: '/',
		meta: { layout: 'default' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/Home.vue')
	},
	/**
	 * @brief 호반on 링크
	 */
	{
		name: 'hoban',
		path: '/HobanON',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/HobanLink.vue')
	},

	/**
	 * @brief 서한 링크
	 */
	{
		name: 'seohan',
		path: '/seohan',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 남해종합건설 링크
	 */
	{
		name: 'namhae',
		path: '/namhae',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 화성산업 링크
	 */
	{
		name: 'HS',
		path: '/HS',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/sh.vue')
	},

	/**
	 * @brief 극동건설 링크
	 */
	{
		name: 'kukdong',
		path: '/kukdong',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/kukdong1.vue')
	},

	/**
	 * @brief 서영건설플러스 링크
	 */
	{
		name: 'syplus',
		path: '/syplus',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/syplus.vue')
	},

	/**
	 * @brief 동원개발 링크
	 */
	{
		name: 'dongwon',
		path: '/dongwon',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 제주특별자치도개발공사 링크
	 */
	{
		name: 'jpdc',
		path: '/jpdc',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 신세계건설 링크
	 */
	{
		name: 'ssgenc',
		path: '/ssgenc',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 모아건설 링크
	 */
	{
		name: 'moa',
		path: '/moa',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 서희건설 링크
	 */
	{
		name: 'seohee',
		path: '/seohee',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 계룡건설 링크
	 */
	{
		name: 'krcon',
		path: '/krcon',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 진흥기업 링크
	 */
	{
		name: 'chinhung',
		path: '/chinhung',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 효성중공업 링크
	 */
	{
		name: 'hyosung',
		path: '/hyosung',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 남광토건 링크
	 */
	{
		name: 'namkwang',
		path: '/namkwang',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief HJ중공업 링크
	 */
	{
		name: 'hjsc',
		path: '/hjsc',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 동부건설 링크
	 */
	{
		name: 'dongbu',
		path: '/dongbu',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief SM우방 링크
	 */
	{
		name: 'woobang',
		path: '/woobang',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 석미건설 링크
	 */
	{
		name: 'seokmi',
		path: '/seokmi',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 에스지씨이앤씨 링크
	 */
	{
		name: 'sgcenc',
		path: '/sgcenc',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 대성건설 링크
	 */
	{
		name: 'daesung',
		path: '/daesung',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 한신공영 링크
	 */
	{
		name: 'hanshinc',
		path: '/hanshinc',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 대방건설 링크
	 */
	{
		name: 'dbcons',
		path: '/dbcons',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 대방건설 링크 (별칭)
	 */
	{
		name: 'daebang',
		path: '/daebang',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 주택도시보증공사 링크
	 */
	{
		name: 'hug',
		path: '/hug',
		meta: { layout: 'empty', theme: 'light' },
		component: () => import (/* webpackChunkName: "home" */ '@/views/hoban/ConstructionPageView.vue')
	},

	/**
	 * @brief 404 Not Found
	 */
	{
		name: 'not-found',
		path: '*',
		meta: { layout: 'empty' },
		component: () => import (/* webpackChunkName: "not-found" */ '@/views/NotFound.vue')
	}
];

export default routes;
